import { render, staticRenderFns } from "./SessionChangedWatcher.vue?vue&type=template&id=5ae5378a"
import script from "./SessionChangedWatcher.vue?vue&type=script&lang=js"
export * from "./SessionChangedWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae5378a')) {
      api.createRecord('5ae5378a', component.options)
    } else {
      api.reload('5ae5378a', component.options)
    }
    module.hot.accept("./SessionChangedWatcher.vue?vue&type=template&id=5ae5378a", function () {
      api.rerender('5ae5378a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/components/SessionChangedWatcher.vue"
export default component.exports